import Icon from "../../../../components/Icon/Icon";

export default function PaymentMethod({className, onClickBuy, ...props}) {

    return (

        <div
            id={"payment-method"}
            className={`bg-[#F0F7FF] mt-8 flex justify-center items-center flex-col lg:pl-[7rem]  ${className}`}>
            <p className={"text-4xl lg:text-[2.25rem] font-poppins mt-[3rem]  font-extrabold text-black"}>
                Payment Method
            </p>
            <div className={"flex flex-col lg:flex-row px-4 lg:px-0"}>
                <div className={"flex flex-col gap-3 my-8 lg:my-[7rem] flex-[2]"}>
                    <p className={" text-3xl lg:text-[3.3125rem] font-poppins font-extrabold text-black"}>
                        Stripe

                    </p>
                    <p className={"font-normal opacity-0 text-xs lg:text-base text-gray-400"}>
                        Lorem ipsum dolor sit amet consectetur. Elit senectus est sodales Faucibus pellentesque
                        tristique enim magna curabitur adipiscing tempus odio sed.
                    </p>
                    <div className={"flex flex-row mt-2 "}>

                        <div onClick={onClickBuy}
                             className={"cursor-pointer w-[40%]  flex gap-2 flex-row justify-center items-center py-2 bg-secondary-900  rounded-lg text-white"}>
                            <Icon name={"card"} className={"h-6"}/>
                            <p className={"whitespace-nowrap text-xs lg:text-base"}>
                                Credit or Debit Card

                            </p>
                        </div>
                    </div>
                </div>
                <div className={'flex-[2]  flex justify-center items-center '}>
                    <img src={"/images/cardmachine.svg"} className={"w-1/2"} alt={"bg"}/>


                </div>
            </div>
        </div>

    )
}